export default __webpack_public_path__ + "static/media/SourceSansPro-Regular.otf.c74cb4d5.woff2";